import { Box, Grid, styled } from "@mui/material";
import { Icon, IconBadge } from "components/Icons";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import Unit from "./Unit.model";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";


function getDataTime(v) {
  if (!v) return ["", ""];
  
  const [datePart, timePart] = v.split(" ");
  if (!datePart) return ["", ""];
  
  const [year, month, day] = datePart.split("-");
  const time = timePart?.slice(0, -3) ?? "";
  
  const formattedDate = day && month && year ? `${day}.${month}.${year.slice(2, 4)}` : "";
  
  return [time, formattedDate];
}

function Statistics({ unit }) {
  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? [];
  
  const { bookmarked, seen, lastSeen } = unit.getStatistics();
  const [time, date] = getDataTime(lastSeen.LastShownValue);
  
  const projectNo = unit.getProjectNo();
  
  const statisticsLabel = buttonsLabel?.find(btn => btn?.UILabelProperty === 'statistikOverskrift')?.Label;

  return (
    <Box
      sx={{
        py: { xs: 5 },
        px: { xs: 3, md: 5 },
        // backgroundColor: "secondary.main",
        background: `linear-gradient(180deg, ${clr.primary} 0%, ${clr.primary}7d 100%)`,
        color: clr.primary_text,
      }}
    >
      <Box
        sx={{
          mb: { xs: 3, md: 4 },
        }}
       
      >
        <span className="h3">{statisticsLabel} {projectNo}</span>
      </Box>
      <Box
        sx={{
          maxWidth: 500,
        }}
      >
        <Grid container spacing={0}>
          <Grid item xs={4}>
          {/* <div style={{paddingTop:"6px"}}> */}
            <StyledItem>
              
            <IconBadge style={{color:clr?.primary_text, fontSize: '50px'}} icon="heart_empty" />
            
              {/* <Icon icon="heart" /> */}
              <div className="paragraph1-light" style={{ marginTop: "8px" }}>{bookmarked.bookmarkedLabel}</div>
              <div className="h2">{bookmarked.bookmarkedValue}</div>
            </StyledItem>
            {/* </div> */}
          </Grid>
          <Grid item xs={4}>
            <StyledItem>
              <Icon icon="eye" />
              <div className="paragraph1-light">{seen.seenLabel}</div>
              <div className="h2">{seen.seenValue}</div>
            </StyledItem>
          </Grid>
          <Grid item xs={4}>
            <StyledItem>
              <Icon icon="clock" />
              <div className="paragraph1-light" >
                {lastSeen.LastSeenLabel} {date}
              </div>
              <div className="h2">{time}</div>
            </StyledItem>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

Statistics.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};

const StyledItem = styled((props) => <Box {...props} />)({
  padding: "0 10px",
  maxWidth: "100%",
  textAlign: "center",
  ".MuiSvgIcon-root": {
    fontSize: 50,
    marginBottom: "8px",
  },
  "> div:last-child": {
    // fontSize: 30,
    fontWeight: 700,
    lineHeight: 1,
    marginTop: "8px",
  },
});

export default Statistics;
